import React, { FunctionComponent } from 'react';

interface Props {
    children: any;
}

const FilterPageRight: FunctionComponent<Props> = ({ children }) => {

    return (
        <div className={'filter-page__university-content'}>
            { children }
        </div>
    );
};

export default FilterPageRight;
